module.exports = __webpack_public_path__ + "static/media/status-on.d613603f.svg";